import { fetchApi } from "./index";

export interface ProfileSection {
  id: string;
  title: string;
  description: string;
  image_url?: string;
  position: number;
  metadata: Record<string, unknown>;
  created_at: string;
  updated_at: string;
}

export const getProfileSections = async (userId: string) => {
  const { data } = await fetchApi<ProfileSection[]>({
    url: `/v2/profile-sections/user/${userId}`,
    method: "GET",
  });
  return data;
};

export const createProfileSection = async (
  userId: string,
  title: string,
  description: string,
  metadata: Record<string, unknown> = {},
) => {
  const { data } = await fetchApi<ProfileSection>({
    url: `/v2/profile-sections/user/${userId}`,
    method: "POST",
    data: {
      title,
      description,
      metadata,
    },
  });
  return data;
};

export const createProfileSectionWithImage = async (
  userId: string,
  title: string,
  description: string,
  file: File,
  metadata: Record<string, unknown> = {},
) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("title", title);
  formData.append("description", description);
  formData.append("metadata", JSON.stringify(metadata));

  const { data } = await fetchApi<ProfileSection>({
    url: `/v2/profile-sections/user/${userId}/image`,
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};

export const updateProfileSection = async (
  sectionId: string,
  title?: string,
  description?: string,
  metadata?: Record<string, unknown>,
) => {
  const { data } = await fetchApi<ProfileSection>({
    url: `/v2/profile-sections/${sectionId}`,
    method: "PUT",
    data: {
      ...(title && { title }),
      ...(description && { description }),
      ...(metadata && { metadata }),
    },
  });
  return data;
};

export const updateProfileSectionImage = async (
  sectionId: string,
  file: File,
) => {
  const formData = new FormData();
  formData.append("file", file);

  const { data } = await fetchApi<ProfileSection>({
    url: `/v2/profile-sections/${sectionId}/image`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};

export const removeProfileSectionImage = async (sectionId: string) => {
  const { data } = await fetchApi<ProfileSection>({
    url: `/v2/profile-sections/${sectionId}`,
    method: "PUT",
    data: {
      image_url: null,
    },
  });
  return data;
};

export const deleteProfileSection = async (sectionId: string) => {
  await fetchApi({
    url: `/v2/profile-sections/${sectionId}`,
    method: "DELETE",
  });
};

export const reorderProfileSections = async (
  userId: string,
  sectionIds: string[],
) => {
  const { data } = await fetchApi<ProfileSection[]>({
    url: `/v2/profile-sections/user/${userId}/reorder`,
    method: "POST",
    data: {
      sectionIds,
    },
  });
  return data;
};
